module.exports = __webpack_public_path__ + "img/gift.b7f8dc79.svg";